import './no-match.css';

function NoMatch() {
  return (
    <div className="no-match">
      <div className="no-match__container">
        <img 
          src="../img/404page/404-illustration.svg" 
          alt="404 - Pagina niet gevonden"
          className="no-match__image"
        />
        <div className="no-match__content">
          <h1 className="no-match__title">Oh no! Error 404</h1>
          <p className="no-match__description">
            Sorry we couldn&#39;t find the page you were looking for
          </p>
        </div>
      </div>
    </div>
  );
}

export default NoMatch;